import { WellLogsManagerWidgetWrapper } from '../../well-logs-manager-widget/WellLogsManagerWidget';
import type { WellLogsManagerWidgetEntity } from '../../well-logs-manager-widget/WellLogsManagerWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderWellLogsManagerWidget(
  widget: WellLogsManagerWidgetEntity,
  options: TWidgetRendererOptions,
): TRenderWidget {
  return () => <WellLogsManagerWidgetWrapper entity={widget} options={options} />;
}
